export interface DoPaymentRequest {
  lang: string;
}
